// alert
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';

// user
export const SET_USER = 'SET_USER';
export const SET_USER_NAME = 'SET_USER_NAME';
export const ADD_SEARCH_TARGET = 'ADD_SEARCH_TARGET';
export const RESET_SEARCH_TARGETS = 'RESET_SEARCH_TARGETS';

// projects
export const SET_PROJECTS = 'SET_PROJECTS';
export const SET_SHARED_PROJECTS = 'SET_SHARED_PROJECTS';
export const SET_SEARCHED_PROJECTS = 'SET_SEARCHED_PROJECTS';
export const FILTER_PROJECTS = 'FILTER_PROJECTS';

// project
export const SET_PROJECT = 'SET_PROJECT';
export const SET_PROJECT_COLLECTION = 'SET_PROJECT_COLLECTION';
export const SELECT_PROJECT = 'SELECT_PROJECT';
export const RESET_PROJECT_STATUS = 'RESET_PROJECT_STATUS';

export const SET_PROJECT_NAME = 'SET_PROJECT_NAME';
export const TOGGLE_PROJECT_NAME = 'TOGGLE_PROJECT_NAME';

// settings
export const SET_SETTING = 'SET_SETTING';

// information
export const SET_INFORMATION = 'SET_INFORMATION';

// pixi-instruction
export const SET_INSTRUCTION = 'SET_INSTRUCTION';

// pixi-canvas
export const SET_CANVAS_SCALE = 'SET_CANVAS_SCALE';
export const SET_CANVAS_TOOL = 'SET_CANVAS_TOOL';
export const SET_CANVAS_ORTHO = 'SET_CANVAS_ORTHO';
export const ADD_CANVAS_ELEMENT = 'ADD_CANVAS_ELEMENT';
export const REMOVE_CANVAS_ELEMENT = 'REMOVE_CANVAS_ELEMENT';
export const SELECT_CANVAS_ELEMENT = 'SELECT_CANVAS_ELEMENT';

// camera
export const SET_CAMERA_POSITION = 'SET_CAMERA_POSITION';

// furniture
export const SET_FURNITURE_POSITION = 'SET_FURNITURE_POSITION';
export const SET_FURNITURE_ROTATION = 'SET_FURNITURE_ROTATION';

// wall
export const SET_WALL_COLOR = 'SET_WALL_COLOR';

// opening
export const SET_OPENING_POSITION = 'SET_OPENING_POSITION';
export const SET_OPENING_ROTATION = 'SET_OPENING_ROTATION';

// covering
export const SET_COVERING_TEXTURE = 'SET_COVERING_TEXTURE';

// three-rendering
export const SET_RENDERING_DATAURL = 'SET_RENDERING_DATAURL';
export const SET_DIRECTIONAL_LIGHT = 'SET_DIRECTIONAL_LIGHT';
export const SET_HEMISPHERE_LIGHT = 'SET_HEMISPHERE_LIGHT';
export const SET_BACKGROUND_COLOR = 'SET_BACKGROUND_COLOR';
